"use client"

import { BadgeSwissFranc } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BadgeSwissFrancIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BadgeSwissFrancIcon = component(Icon)({ as: BadgeSwissFranc })
